import type { SampleExamApiQuestion } from '../../../services/sampleExamTypes';

export type { SampleExamApiQuestion } from '../../../services/sampleExamTypes';

/**
 * Sorts by `order` and fills default `options` / `matchPairs` without renaming any API fields.
 */
export function mapSampleExamQuestionsToQuestions(
  raw: SampleExamApiQuestion[]
): SampleExamApiQuestion[] {
  return [...raw]
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .map((q) => ({
      ...q,
      options: q.options ?? [],
      matchPairs: q.matchPairs ?? [],
    }));
}
